export default function AppLogo() {
  return (
    <span className="flex items-center">
      <span className="text-brand font-brand text-lg font-semibold">
        Stitch
      </span>
      <img src="/logo.png" alt="Stitch logo" className="h-8 dark:hidden" />
      <img
        src="/logo-dark.png"
        alt="Stitch logo"
        className="hidden h-8 dark:block"
      />
    </span>
  )
}
